import React, { useState } from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { HomeScreen } from './HomeScreen.js';
import { SiteSelectorScreen } from './SiteSelectorScreen.js';
import { ScreenState } from './screen-state.js';
import { DashboardScreen } from './DashboardScreen.js';
import { BackendScreen } from './BackendScreen.js';

export const DevCommandScreens: FC = () => {
  const [screen, setScreen] = useState<ScreenState>(ScreenState.Home());

  return match(screen, {
    Home: () => <HomeScreen onScreenChange={setScreen} />,
    SiteSelector: () => <SiteSelectorScreen onScreenChange={setScreen} />,
    DashboardScreen: ({ selectorType }) => (
      <DashboardScreen
        initialSelectorType={selectorType}
        onSelect={() => setScreen(ScreenState.Home())}
        onClose={() => setScreen(ScreenState.Home())}
      />
    ),
    BackendScreen: ({ selectorType }) => (
      <BackendScreen
        initialSelectorType={selectorType}
        onSelect={() => setScreen(ScreenState.Home())}
        onClose={() => setScreen(ScreenState.Home())}
      />
    ),
  });
};
